module.exports = __webpack_public_path__ + "img/Flag_of_Rwanda.559f166d.svg";